if (!customElements.get('wishlist-items')) {
  customElements.define(
    'wishlist-items',
    class WishlistItems extends HTMLElement {
      constructor() {
        super();
      }

      renderResults() {
        wishlist_items.length === 0 ? this.innerHTML = `` 
          : this.innerHTML = `
            <div class="relative z-[1]">
              <button 
                id="data-swiper-prev-wishlist-item"  
                class="justify-center z-10 absolute top-[77px] left-0 bg-secondaryLight w-8 h-6 max-w-8 max-h-6 min-w-8 min-h-6 flex items-center disabled:opacity-0 transition [&_svg]:origin-center [&_svg]:transform [&_svg]:scale-x-[-1]"
              >
                <svg class="transform -scale-x-100" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                  <path d="M6.75 3.75L12 9L6.75 14.25" stroke="#1C1C1C" stroke-width="2" stroke-linecap="square"/>
                </svg>
              </button>
              <button 
                id="data-swiper-next-wishlist-item"  
                class="justify-center z-10 absolute top-[77px] right-0 bg-secondaryLight w-8 h-6 max-w-8 max-h-8 min-w-6 min-h-6 flex items-center disabled:opacity-0 transition"
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                  <path d="M6.75 3.75L12 9L6.75 14.25" stroke="#1C1C1C" stroke-width="2" stroke-linecap="square"/>
                </svg>
              </button>
              <swiper-container 
                space-between="4" 
                slides-per-view="${this.dataset.slidesPerView}"
                navigation="true"
                navigation-next-el="#data-swiper-next-wishlist-item"
                navigation-prev-el="#data-swiper-prev-wishlist-item"
              >
                ${wishlist_items.map((item) => `
                  <swiper-slide>
                    <intersection-loader 
                      data-load-immediately="true"
                      data-url="/products/${item.du.split(`/products/`)[1]}"
                      data-section-id="upsell-tile"
                    ></intersection-loader>    
                  </swiper-slide>
                `).join('')}
              </swiper-container>
            </div>
          `;
      }

      init() {
        this.renderResults(); 

        document.addEventListener('click', (ev) => {
          const clickedElement = ev.target.closest('[data-action="move-to-wishlist"]');
          if (!clickedElement) return;

          const {
            productId,
            variantId,
            itemKey,
            url,
          } = clickedElement.dataset;

          const product = {
            epi: variantId,
            empi: productId,
            du: `${window.location.origin}${url}`,
          }

          const wishlist_icons = document.querySelectorAll(`[data-wishlist-product-id="${productId}"]`);

          const addSuccess = () => {
            swym_swat.fetchLists({
              callbackFn: getListSuccess,
              errorFn: swymOnError,
            });

            wishlist_icons.forEach(icon => {
              const svg = icon.querySelector('svg');

              svg.classList.add('heart-icon-soft-red');
              svg.classList.remove('heart-icon-white');
            });
          }

          const swymError = (error) => {
            console.error("Error while adding the Product to the List", error);
            alert(`Error while adding the Product to the List: ${error}`);
          }

          swym_swat.addToList(default_list_id, product, addSuccess, swymError);

          window.dispatchEvent(new CustomEvent('cart:removeItem', { detail: { itemKey } }));
        });

        document.addEventListener(`wishlist-items-updated`, () => {
          this.renderResults();
        });
      }

      connectedCallback() {
        poll(() => {
          return wishlist_items;
        }, 10000, 150).then(() => {
          this.init();
        });

      }    
  });
}